export const localStorageKeys = {
    CONTEXT_ORG: 'contextOrg',
    SKIP_WIZARD: 'skipWizard',
    OAUTH2_STATE: 'state'
};
